/**
 * 判断手指移动方向
 * @author libaoxu@gaosiedu.com
 * @date 2016-11-1
 */

/**
 * 移动距离衡量标准的绝对值, 默认30px, 小于这个距离判断误触
 * @type {Number}
 */
const rangeNum = 20;

/**
 * 移动时间差值, 默认100毫秒, 小于这个距离判断误触
 * @type {Number}
 */
const rangeTime = 50;

export default {
  name: 'swiper-direction',

  bind () {

    this.swiperX = false;
    this.swiperY = false;

    // 更改addEventListener时,this指向, 又能让removeEventListener时, 找到对应解绑方法
    this.touchStartBind = this.touchStart.bind(this);
    this.touchMoveBind = this.touchMove.bind(this);
    this.touchEndBind = this.touchEnd.bind(this);

    // 绑定touch开始 和 结束事件, 并且更改this指向
    this.el.addEventListener('touchstart', this.touchStartBind);

    this.el.addEventListener('touchmove', this.touchMoveBind);

    this.el.addEventListener('touchend', this.touchEndBind);

  },

  update (newValue, oldValue) {

  },

  unbind () {
    this.el.removeEventListener('touchstart', this.touchStartBind);

    this.el.removeEventListener('touchmove', this.touchMoveBind);

    this.el.removeEventListener('touchend', this.touchEndBind);
  },

  /**
   * touchstart 事件监听函数, this指向不是dom, 是Vue.directive(string, definition)的第二个参数: definition
   */
  touchStart (e) {
    let touches = e.touches[0] || e.changedTouches[0];

    // touch事件开始页面中pageX值
    this.startX = touches.pageX;

    // touch事件开始页面中pageY值
    this.startY = touches.pageY;
    
    // 开始碰触时间
    this.startTime = Date.now();

    document.ontouchmove = function (e) {
      e.preventDefault();
      return false;
    }

  },

  /**
   * touchmove 事件监听函数
   */
  touchMove (e) {
    let touches = e.touches[0] || e.changedTouches[0];
    
    let disX = touches.pageX - this.startX;
    let disY = touches.pageY - this.startY;

    Object.assign(e, {
      disX,
      disY
    })

    this.vm.swiperMove && this.vm.swiperMove(e);
  },

  /**
   * touchEnd 事件监听函数
   */
  touchEnd (e) {
    let touches = e.touches[0] || e.changedTouches[0];
    
    // 结束时间差
    let disTime = Date.now() - this.startTime;

    // 开始和结束移动距离
    this.disX = touches.pageX - this.startX;
    this.disY = touches.pageY - this.startY;

    // 时间差值, 小于100ms 可能是误触
    if (disTime < rangeTime) {
      e.preventDefault();
      return false;
    }

    // 距离平方差, 来判断上下左右方向
    let directionNum = Math.abs(this.disX) - Math.abs(this.disY);

    // 左右方向
    if (directionNum > 0) {
      this.swiperX = true;
      // 右侧移动
      if (this.disX > rangeNum) {
        this.vm.swiperRight && this.vm.swiperRight(e);
      }

      // 左侧移动
      if (this.disX < -rangeNum) {
        this.vm.swiperLeft && this.vm.swiperLeft(e);
      }
      
    } else {
      // 上下方向
      this.swiperY = true;

      // 距离大于rangeNum, 表示移动, 小于rangeNum 可能误触, 不做处理
      if (this.disY > rangeNum) {
        // 向下移动
        this.vm.swiperDown && this.vm.swiperDown(e);
      }

      if (this.disY < -rangeNum) {
        // 向上移动
        this.vm.swiperUp && this.vm.swiperUp(e);
      }
    }

    this.swiperX = false;
    this.swiperY = false;

    document.ontouchmove = document.ontouchend = null;
  }

}